<ng-template #urlsMenu let-urls="urls">
	<reach-menu cdkMenu class="p-1 br-1h" style="width: 216px">
		<div class="w-100 fl fl-ai-c fl-dir-c fl-gap-0q ov-a" style="max-height: 320px">
			@for (url of urls; track $index) {
				<a
					[title]="url"
					[href]="url"
					target="_blank"
					class="w-100 fl p-0h-tb p-1-rl br-0t bg-standard-hover-on-hover fl-gap-1 fl-ai-c"
				>
					<i class="icon-www-url fs-sp-2 node-type-color color-website"></i>
					<span class="fs-sp-1t ellipsis" style="line-height: 20px">
						{{ url }}
					</span>
				</a>
			}
		</div>
	</reach-menu>
</ng-template>

<ng-template
	#sourceCardTpl
	let-item="item"
	let-expanded="expanded"
	let-withBg="withBg"
	let-canToggle="canToggle"
	let-inBottomMenu="inBottomMenu"
	let-selected="selected"
>
	<div
		[attr.role]="expanded ? 'button' : null"
		class="w-100 br-1h p-1 fl fl-dir-c fl-ai-fs fl-jc-fs fl-gap-1h"
		[class.bg-standard-hover-on-hover]="canToggle || !expanded"
		[class.bg-190]="!withBg"
		[class.bg-280]="withBg"
		[style.cursor]="expanded && !canToggle ? null : 'pointer'"
		[style.max-height]="$smallScreen() && expanded ? '50%' : null"
		(click)="canToggle ? toggleSmallScreen() : openNode(item.node.id)"
	>
		<div class="w-100 fl fl-ai-c fl-jc-fs fl-gap-1h">
			<!-- NODE -->
			<common-node-thumbnail
				[node]="item.node"
				class="fl-fixed"
				style="width: calc(5 * var(--spacing)); height: calc(5 * var(--spacing))"
			>
				<!-- NODE IMG -->
			</common-node-thumbnail>

			<div class="fl-adaptable ellipsis fl fl-dir-c fl-ai-fs fl-jc-fs fl-gap-0h">
				<p
					#nodeNameElement
					class="w-100 ellipsis fc-800"
					[tooltip]="$showNameTooltip() ? item.node.name : null"
					(mouseover)="updateNameTooltip(nodeNameElement)"
				>
					{{ item.node.name }}
				</p>
				<div class="fl fl-ai-c fl-gap-0h">
					@if (item.certified) {
						<i class="icon-bold-verified-check fc-primary fs-sp-1h"></i>
					} @else {
						<i class="fl-fixed fs-sp-1h" [nodeTypeIcon]="item.node.nodeType"></i>
					}
					<span class="fc-400 fs-sp-1h">{{ item.creationFileDate }}</span>
				</div>
			</div>

			@if (inBottomMenu) {
				<i
					class="fl-fixed"
					[class.icon-bold-tick-circle]="selected"
					[class.fc-primary]="selected"
					[class.icon-chevron]="!selected"
					[class.chevron-right]="!selected"
					[class.fc-400]="!selected"
				></i>
			} @else {
				<i
					class="fl-fixed icon-chevron fc-400"
					[class.chevron-up]="expanded"
					[class.chevron-down]="!expanded"
				></i>
			}
		</div>

		@if (canToggle || expanded) {
			<div class="w-100 fl fl-ai-c fl-jc-fs fl-gap-1">
				@if (configuration.canNavigateToNode) {
					<!-- ACTIONS -->
					@if (canOpenNodeCurrentClient) {
						<a
							title="Go to node"
							commonButtonFilled
							[routerLink]="['/', 'home', 'node', item.node.id]"
							size="XS"
							class="fl-adaptable ellipsis fl-jc-c hover-parent"
							style="
								width: calc((100% - var(--spacing)) * 0.5);
								background-color: var(--color-bg-170);
							"
							(click)="closeModal()"
						>
							<i
								class="icon-unassigned-nodes-no-relationships fs-icon-s fc-primary-on-hover-parent"
							></i>
							<span class="ellipsis">Go to node</span>
						</a>
					} @else {
						<a
							commonButtonFilled
							[href]="['home', 'node', item.node.id] | mainClientUrl"
							target="_blank"
							size="XS"
							class="fl-adaptable ellipsis fl-jc-c hover-parent"
							style="
								width: calc((100% - var(--spacing)) * 0.5);
								background-color: var(--color-bg-170);
							"
						>
							<i
								class="icon-knowledge-network fs-icon-s fc-primary-on-hover-parent"
							></i>
							<span class="ellipsis">Go to node</span>
						</a>
					}
					<!--  -->
				}
				<!--  -->
				@if (item.node | nodeAsFile; as file) {
					@if (customDownloadLogic) {
						<div
							title="Download"
							[attr.role]="'button'"
							commonButtonFilled
							size="XS"
							class="fl-adaptable ellipsis fl-jc-c hover-parent"
							[style.cursor]="'pointer'"
							style="
								width: calc((100% - var(--spacing)) * 0.5);
								background-color: var(--color-bg-170);
							"
							(click)="$event.stopPropagation(); customDownload(file)"
						>
							<i
								class="fl-fixed icon-download fs-icon-s fc-primary-on-hover-parent"
							></i>
							<span class="ellipsis">Download</span>
						</div>
					} @else if (!!showDownloadButton()) {
						<a
							title="Download"
							commonButtonFilled
							[href]="fileUrl(file)"
							target="_blank"
							download
							size="XS"
							class="fl-adaptable ellipsis fl-jc-c hover-parent"
							style="
								width: calc((100% - var(--spacing)) * 0.5);
								background-color: var(--color-bg-170);
							"
						>
							<i
								class="fl-fixed icon-download fs-icon-s fc-primary-on-hover-parent"
							></i>
							<span class="ellipsis">Download</span>
						</a>
					}
					@if (file.data.websitesToOpen; as fileWebsiteUrls) {
						@if (fileWebsiteUrls.length === 1) {
							<a
								title="Visit Website"
								commonButtonFilled
								[href]="fileWebsiteUrls[0]"
								target="_blank"
								size="XS"
								class="fl-adaptable ellipsis fl-jc-c hover-parent"
								style="
									width: calc((100% - var(--spacing)) * 0.5);
									background-color: var(--color-bg-170);
								"
							>
								<i
									class="fl-fixed icon-open-website fs-icon-s fc-primary-on-hover-parent"
								></i>
								<span class="ellipsis">Visit Website</span>
							</a>
						} @else {
							<div
								title="Visit Websites"
								#menusBtn="cdkMenuTriggerFor"
								[cdkMenuTriggerFor]="urlsMenu"
								[cdkMenuTriggerData]="{ urls: fileWebsiteUrls }"
								commonButtonFilled
								size="XS"
								class="fl-adaptable ellipsis fl-jc-c hover-parent cursor-pointer"
								style="
									width: calc((100% - var(--spacing)) * 0.5);
									background-color: var(--color-bg-170);
								"
							>
								<i
									class="fl-fixed icon-open-website fs-icon-s fc-primary-on-hover-parent"
								></i>
								<span class="ellipsis">Visit Websites</span>
							</div>
						}
					}
					<!--  -->
				}
				@if (item.node | nodeAsWebsite; as website) {
					<a
						title="Visit Website"
						commonButtonFilled
						[href]="website.data.url"
						target="_blank"
						size="XS"
						class="fl-adaptable ellipsis fl-jc-c hover-parent"
						style="
							width: calc((100% - var(--spacing)) * 0.5);
							background-color: var(--color-bg-170);
						"
					>
						<i
							class="fl-fixed icon-open-website fs-icon-s fc-primary-on-hover-parent"
						></i>
						<span class="ellipsis">Visit website</span>
					</a>
				}
			</div>
		}
		<!--  -->
		@if (expanded) {
			<div
				class="w-100 fl fl-dir-c fl-ai-fs fl-jc-fs fl-gap-1h p-0h-rl p-1-tb"
				[style.overflow-y]="$smallScreen() && expanded ? 'scroll' : null"
			>
				@for (source of item.sources; track source.id) {
					<!-- SOURCE -->
					<button
						class="w-100 fl fl-ai-fs fl-jc-fs fl-gap-1 hover-parent"
						(click)="$event.stopPropagation(); selectSource(source)"
					>
						<div
							class="fl-fixed fl fl-ai-c fl-jc-c br-circle fs-xs ov-h fc-white"
							style="
								width: calc(2 * var(--spacing));
								height: calc(2 * var(--spacing));
								background-color: var(--color-line-330);
							"
						>
							<div class="w-100 h-100 fl fl-ai-c fl-jc-c bg-primary-on-hover-parent">
								{{ source.inlineNumber }}
							</div>
						</div>
						<p
							class="fl-adaptable"
							style="
								--l-h: var(--fs-l);
								line-height: var(--l-h);
								max-height: calc(var(--l-h) * 2);
								display: -webkit-box;
								-webkit-line-clamp: 2;
								line-clamp: 2;
								-webkit-box-orient: vertical;
								overflow: hidden;
							"
						>
							@if (item.previewType === SourcePreviewType.PDF) {
								<span class="fc-400">
									<span class="fc-primary-on-hover-parent">
										Pg.{{ source.data.boundingBox.page }}&nbsp;-&nbsp;
									</span>
								</span>
							}

							<span class="fc-800 fs-sp-1h" style="word-break: break-all">
								{{ source.content }}
							</span>
						</p>
					</button>
				}
			</div>
		}
	</div>
</ng-template>

<div
	class="pos-rel w-100 h-100 fl fl-jc-c"
	[class.fl-ai-c]="!$smallScreen()"
	[class.fl-ai-fe]="$smallScreen()"
	style="--spacing: 8px; background-color: rgba(0, 0, 0, 0.2); backdrop-filter: blur(4px)"
	(click)="closeModal()"
>
	<div
		class="modal-content shadow-menu bg-190 fl fl-dir-c fl-ai-fs fl-jc-fs fl-gap-0h ov-h bordered border-250 br-3"
		[class.p-safe-b]="$smallScreen()"
		[class.small-screen]="$smallScreen()"
		[class.fullscreen]="configuration.modalFullscreen"
		(click)="$event.stopPropagation()"
	>
		<div class="fl-fixed w-100 p-2-rl p-1h-tb fl fl-ai-c fl-jc-fs fl-gap-1">
			@if ($smallScreen()) {
				<button commonButtonIcon (click)="toggleShowingAllSourcesMenu()">
					<i class="icon-text-editor-bullet-list"></i>
				</button>
			} @else {
				<div commonButtonIcon class="invisible">
					<i class="icon-cross-close"></i>
				</div>
			}

			<p
				class="fl-adaptable fw-bold ellipsis ta-center"
				[class.fs-sp-2q]="!$isDesktop()"
				[class.fs-h5]="$isDesktop()"
			>
				Answer Sources
			</p>

			<button commonButtonIcon (click)="closeModal()">
				<i class="icon-cross-close"></i>
			</button>
		</div>

		<div
			class="fl-adaptable ov-h w-100 p-2-b p-1-rl fl fl-ai-fs fl-jc-fs fl-gap-1"
			[class.fl-dir-c]="$smallScreen()"
		>
			@if ($smallScreen()) {
				<!--  -->
				@if ($selectedItem(); as selected) {
					<ng-container
						[ngTemplateOutlet]="sourceCardTpl"
						[ngTemplateOutletContext]="{
							item: selected,
							expanded: $smallCardExpanded(),
							withBg: true,
							canToggle: true,
							inBottomMenu: false,
							selected: false,
						}"
					></ng-container>
				}
				<!--  -->
			}

			<div
				class="fl-adaptable ov-h"
				[class.pos-rel]="$smallScreen()"
				[class.w-100]="$smallScreen()"
				[class.h-100]="!$smallScreen()"
			>
				<!--  -->
				@switch ($selectedItem()?.previewType) {
					<!--  -->
					@case (SourcePreviewType.PDF) {
						<!--  -->
						@if ($selectedFile(); as file) {
							<pdf-preview
								class="w-100 h-100"
								[node]="file.node"
								[sources]="file.sources"
								[selectedSource]="$selectedSourceIdAsObj()"
							></pdf-preview>
						}
						<!--  -->
					}
					<!--  -->
					@case (SourcePreviewType.AUDIO) {
						<!--  -->
						@if ($selectedFile(); as file) {
							<source-preview-with-sources
								class="w-100 h-100"
								[sources]="$selectedItem()?.sources ?? []"
							>
								<audio-preview
									class="w-100 bg-170 br-1h"
									[node]="file.node"
								></audio-preview>
							</source-preview-with-sources>
						}
						<!--  -->
					}
					<!--  -->
					@case (SourcePreviewType.VIDEO) {
						<!--  -->
						@if ($selectedFile(); as file) {
							<source-preview-with-sources
								class="w-100 h-100"
								[sources]="$selectedItem()?.sources ?? []"
							>
								<video-preview
									class="w-100 bg-170 br-1h ov-h"
									[node]="file.node"
								></video-preview>
							</source-preview-with-sources>
						}
						<!--  -->
					}
					<!--  -->
					@case (SourcePreviewType.IMAGE) {
						<!--  -->
						@if ($selectedFile(); as file) {
							<image-preview
								class="w-100 h-100 bg-170 br-1h ov-h pos-rel"
								[file]="file.node"
							></image-preview>
						}
						<!--  -->
					}
					<!--  -->
					@default {
						<source-preview-with-sources
							class="w-100 h-100"
							[sources]="$selectedItem()?.sources ?? []"
							[showContent]="false"
						></source-preview-with-sources>
					}
					<!--  -->
				}
				<!--  -->
			</div>

			@if (!$smallScreen()) {
				<div
					class="fl-fixed fl fl-dir-c fl-ai-fs fl-jc-fs fl-gap-1 ov-auto"
					[class.h-100]="!$smallScreen()"
					[style.width]="$smallScreen() ? '100%' : '280px'"
				>
					@for (item of $rightItems(); track item.node.id) {
						<ng-container
							[ngTemplateOutlet]="sourceCardTpl"
							[ngTemplateOutletContext]="{
								item: item,
								expanded: item.selected,
								withBg: item.selected,
								canToggle: false,
								inBottomMenu: false,
								selected: false,
							}"
						></ng-container>
					}
				</div>
			}
		</div>
	</div>

	@if ($smallScreen() && $showingAllSourcesMenu()) {
		<div
			class="w-100 h-100 pos-abs pos-t-0 pos-l-0 fl fl-ai-fe fl-jc-fs"
			style="background-color: rgba(0, 0, 0, 0.2); backdrop-filter: blur(4px)"
			(click)="toggleShowingAllSourcesMenu(); $event.stopPropagation()"
		>
			<div
				class="pos-rel shadow-menu bg-280 w-100 br-1q-tr br-1q-tl fl fl-dir-c fl-ai-fs fl-jc-fs fl-gap-1 ov-auto p-safe-b"
				style="max-height: calc(100% - (8 * var(--spacing)))"
				(click)="$event.stopPropagation()"
			>
				<div
					class="fl-fixed w-100 fl fl-ai-c fl-jc-fs p-2-rl p-1h-tb pos-sticky pos-t-0 bg-280 z-index-1"
				>
					<div commonButtonIcon class="invisible">
						<i class="icon-cross-close"></i>
					</div>

					<p
						class="fl-adaptable fw-bold ellipsis ta-center"
						[class.fs-icon]="$isDesktop()"
					>
						All used sources
					</p>

					<button
						commonButtonIcon
						(click)="toggleShowingAllSourcesMenu(); $event.stopPropagation()"
					>
						<i class="icon-cross-close"></i>
					</button>
				</div>

				@for (item of $rightItems(); track item.node.id) {
					<div
						class="w-100 fl-fixed p-2-rl"
						(click)="toggleShowingAllSourcesMenu(); $event.stopPropagation()"
					>
						<ng-container
							[ngTemplateOutlet]="sourceCardTpl"
							[ngTemplateOutletContext]="{
								item: item,
								expanded: false,
								withBg: true,
								canToggle: false,
								inBottomMenu: true,
								selected: item.selected,
							}"
						></ng-container>
					</div>
				}

				<div class="w-100 fl-fixed h-0"></div>
			</div>
		</div>
	}
</div>
